

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'order_';

export default {
  path: routePre + '/order',
  name: 'order',
  header: 'order',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	{
	  path: 'index',
	  name: `${pre}index`,
	  meta: {
	    auth: ['order-index'],
	    title: '订单管理',
	  },
	  component: () => import('@/pages/order/index/index'),
	},
	
	{
	  path: 'create',
	  name: `${pre}create`,
	  meta: {
	    auth: ['order-bill-create'],
	    title: '创建订单',
		activeMenu: routePre + '/order/bill',
		hiddenMenu:true
	  },
	  component: () => import('@/pages/order/index/create'),
	},
	
	{
	  path: 'update',
	  name: `${pre}update`,
	  meta: {
	    auth: ['order-update'],
	    title: '修改订单',
		activeMenu: routePre + '/order/index',
	  },
	  component: () => import('@/pages/order/index/update'),
	},
	
	{
	  path: 'refund',
	  name: `${pre}refund`,
	  meta: {
	    auth: ['order-refund'],
	    title: '退款管理',
	  },
	  component: () => import('@/pages/order/refund/index'),
	},
	
	
	{
	  path: 'refund/create',
	  name: `${pre}refundCreate`,
	  meta: {
	    auth: ['order-refund-create'],
	    title: '申请退款',
		activeMenu: routePre + '/order/index',
		hiddenMenu:true
	  },
	  component: () => import('@/pages/order/refund/create'),
	},
	
	{
	  path: 'refund/update',
	  name: `${pre}refundUpdate`,
	  meta: {
	    auth: ['order-refund-update'],
	    title: '修改退款',
		activeMenu: routePre + '/order/refund',
	  },
	  component: () => import('@/pages/order/refund/update'),
	},
	
	{
	  path: 'bill',
	  name: `${pre}bill`,
	  meta: {
	    auth: ['order-bill'],
	    title: '收款账单',
		hiddenMenu:true
	  },
	  component: () => import('@/pages/order/bill/index'),
	},
	
	{
	  path: 'bill/create',
	  name: `${pre}billCreate`,
	  meta: {
	    auth: ['order-bill-create'],
	    title: '录入收款',
		activeMenu: routePre + '/order/bill',
		hiddenMenu:true
	  },
	  component: () => import('@/pages/order/bill/create'),
	},
	
	{
	  path: 'bill/update',
	  name: `${pre}billUpdate`,
	  meta: {
	    auth: ['order-bill-update'],
	    title: '修改收款',
		activeMenu: routePre + '/order/bill',
		hiddenMenu:true
	  },
	  component: () => import('@/pages/order/bill/update'),
	},
	
	
  ],
};
